interface ProgressBarProps {
  percentage: number;
  className?: string;
}

const ProgressBar = ({
  percentage,
  className = "bg-brand-default",
}: ProgressBarProps) => (
  <div className="w-full mt-3 bg-[#E1FBFB] rounded-full h-[8px]">
    <div
      className={`h-[8px] rounded-full ${className}`}
      style={{
        width: `${Math.min(percentage, 100)}%`,
      }}
    />
  </div>
);

export default ProgressBar;
